import React, { FC, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import DataContext from '../../Context';
import { IPolicy } from '../../Models/PolicyInfo';

interface Props {
    children: React.ReactNode
}

const Required: FC<Props> = ({children}) => {
  let navigator = useNavigate();
  const { validKey } = useContext(DataContext) as IPolicy;  

  useEffect(() => {
    if (!validKey) {
      navigator("/NotFound");
    }
  }, [validKey]);

  return (
    <>{validKey && children}</>
  )
}

export default Required;